import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys, helpers } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";

const container: CSSProperties = {
  padding: "20px 26px",
};

const description: CSSProperties = {
  fontFamily: fontFamilySans,
  color: greys.slate,
  fontSize: 14,
  lineHeight: "24px",
  marginBottom: 15,
};

const slackForm: CSSProperties = {
  marginTop: 30,
};

const slackSettings: CSSProperties = {
  border: `1px solid ${greys.borderGrey}`,
  padding: "15px 25px",
};

const slackTeamName: CSSProperties = {
  fontWeight: "bold",
  fontSize: 15,
  color: greys.slate,
  margin: "5px 0 10px",
};

const slackSelectRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

const calloutContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginBottom: 15,
};

const calloutIcon: CSSProperties = {
  color: colors.yellow.darker,
  marginRight: 10,
};

const calloutLabel: CSSProperties = {
  flexGrow: 1,
};

const removeSlackConfirmationBtn: CSSProperties = {
  // backgroundColor: colors.red.standard,
  // color: greys.white,
  color: colors.red.standard,
  "&:hover": {
    backgroundColor: helpers.lighten(colors.red.standard, 0.75),
  },
};

export const styles = {
  container,
  description,
  slackForm,
  slackSettings,
  slackTeamName,
  slackSelectRow,
  calloutContainer,
  calloutIcon,
  calloutLabel,
  removeSlackConfirmationBtn,
};
